const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16',
  }

  return (
    <div className={`animate-spin rounded-full border-2 border-t-primary-600 border-r-primary-600 border-b-transparent border-l-transparent ${sizeClasses[size]} ${className}`} />
  )
}

export default LoadingSpinner